import axios from 'axios';

import logger from './logger';
import logError from './logError';

export const authenticateServer = async (jwt, authBaseUrl, timeout = 5000) => {
  try {
    if (!authBaseUrl) {
      throw new Error('Missing auth base URL');
    }
    const headers = {
      'Content-Type': 'application/json; charset=utf-8',
    };

    const response = await axios.post(
      `${authBaseUrl}/auth/token`,
      { jwt: jwt },
      {
        withCredentials: true,
        headers: headers,
        timeout,
      },
    );

    if (response.status === 200) {
      const loginResponse = await axios.post(
        `${authBaseUrl}/auth/login`,
        { jwt: jwt },
        {
          withCredentials: true,
          headers: headers,
          timeout,
        },
      );

      if (loginResponse.status === 200) {
        const csrfToken = loginResponse.data.csrfToken;

        localStorage.setItem('csrfToken', csrfToken);
        const firstName = response.data.user.firstName || '';
        const lastName = response.data.user.lastName || '';

        localStorage.setItem('groups', JSON.stringify(response.data.groups));
        localStorage.setItem('firstName', firstName || '');
        localStorage.setItem('lastName', lastName || '');

        return {
          firstName,
          lastName,
          groups: response.data.groups,
        };
      } else {
        throw new Error('Login failed with status: ' + loginResponse.status);
      }
    } else {
      throw new Error('JWT token validation failed with status: ' + response.status);
    }
  } catch (error) {
    logger.error(logError(error, { action: 'authenticateServer' }));
    throw error;
  }
};
